import { z } from "zod";
import { RepairFee, RepairInvoiceDetails } from "./get-repair-invoice-details";

export const updateRepairInvoice = {
  input: z.object({ returnId: z.string(), fees: z.array(RepairFee) }),
  output: RepairInvoiceDetails,
};
